import {
  Box,
  InputMessage,
  LinkAnchor,
  mdBumps,
  smBumps,
  Typo,
} from '@wrisk/ui-components'
import { isNil } from 'lodash-es'
import React, { FunctionComponent, useCallback, useState } from 'react'

import { VehicleKBA } from '../../../../../domain'
import {
  TKeyBuilder,
  useWriskTranslation,
} from '../../../../../infrastructure/internationalisation'
import { WriskTrans } from '../../../trans'
import { VehicleLookupInput } from './VehicleLookupInput'
import { VehicleSelect } from './VehicleSelect'

export interface VehicleLookupKBAProps {
  name: string
  value: VehicleKBA | null
  onChange: (value: VehicleKBA | null) => void
  onEmpty?: () => void
  config?: Partial<{
    profile: string
  }>
  tKey: TKeyBuilder
}

export const VehicleLookupKBA: FunctionComponent<VehicleLookupKBAProps> = ({
  name,
  value,
  onChange,
  onEmpty,
  config,
  tKey,
}) => {
  const { t } = useWriskTranslation()

  const [results, setResults] = useState<VehicleKBA[] | null>(null)

  const handleVehicleLookup = useCallback(
    (data: VehicleKBA[]) => {
      data?.length === 1 ? onChange(data[0]) : setResults(data)
    },
    [onChange],
  )

  return (
    <Box display='flex' flexDirection='column' rowGap={smBumps} width={1}>
      <VehicleLookupInput
        tKey={tKey}
        name={name}
        value={value}
        onChange={handleVehicleLookup}
        config={config}
      />
      {isNil(results) ? null : results.length === 0 ? (
        <InputMessage>
          <WriskTrans
            t={t}
            i18nKey={tKey('errors', 'empty')}
            components={{
              EmptyLink: <LinkAnchor variant='inline' onClick={onEmpty} />,
            }}
          />
        </InputMessage>
      ) : (
        <VehicleSelect results={results} value={value} onChange={onChange} tKey={tKey} />
      )}
    </Box>
  )
}
